import api from './axios.v2.withoutTransform'

// Sou-Sou items for My Wallet (SOU-12.1). A separate request, merged client-side with user/wallet; the response is a plain
// { message, items, count } object (not the {statusCode, message, data} envelope).
const list = ({ eventType = 'ACTIVE', sort = 'DATE_ASC', limit = 50, skip = 0, search = '' } = {}) => {
  const params = new URLSearchParams({ eventType, sort, limit, skip })
  if (search) params.set('search', search)
  return api(`souSou/wallet?${params.toString()}`, 'GET')
}

export default { list }
